<style scoped>
ul#orders li {
  display: block;
  padding: 12px 24px;
}
ul.order-head {
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
ul.order-head li {
  float: left;
}

ul.order-head li span {
  display: block;
  padding: 8px;
  cursor: pointer;
  /* padding: 0 1rem; */
}
ul.order-head li.active span {
  color: #b03236;
  /* border-bottom: solid #b03236 3px; */
  font-weight: 600;
  /* background-color: #dddddd; */
}
</style>

<template lang='pug'>
v-container
  .vspace.large
  v-row
    v-col(cols='12')
      p.title.medium Your Orders
      //- .section(v-if='!orders.length')
      //-   p.subtitle.small You haven't made any orders yet
        //- .card(v-else)
        //-   ul#orders
        //-     li.waves-effect(v-for='order in orders', @click='viewOrder(order)')
        //-       p.title.micro {{order.referenceNumber}}
        //-       p.subtitle.micro {{$utils.formatter.formatDateFromNow(order.createdAt)}}
    v-col(cols='12')
      .section
        ul.order-head
          li(
            :class='{ active: activeFilter === "default" }',
            @click='filterOrders("default")'
          )
            span All
          li(
            :class='{ active: activeFilter === "new" }',
            @click='filterOrders("new")'
          )
            span To Pay
          li(
            :class='{ active: activeFilter === "processing" }',
            @click='filterOrders("processing")'
          )
            span To Ship
          li(
            :class='{ active: activeFilter === "in-transit" }',
            @click='filterOrders("in-transit")'
          )
            span To Receive
          li(
            :class='{ active: activeFilter === "delivered" }',
            @click='filterOrders("delivered")'
          )
            span Completed
          li(
            :class='{ active: activeFilter === "declined" }',
            @click='filterOrders("declined")'
          )
            span Cancelled
    v-col(cols='12', sm='8', md='6', lg='6')
      .section
        ul#orders(v-if='filteredOrders.length')
          li.waves-effect.card(
            v-for='order in filteredOrders',
            @click='viewOrder(order)'
          )
            p.title.micro {{ order.referenceNumber }}
            p.subtitle.micro {{ $utils.formatter.formatDateFromNow(order.createdAt) }}
        p.subtitle.small(v-else) {{ activeFilterItemLabel(activeFilter) }}
</template>
<script>
import AppOrderDetails from '@/components/app-order-details'

export default {
  data () {
    return {
      orders: [],
      filteredOrders: [],
      activeFilter: 'default'
    }
  },
  created () {
    this.getOrders()
  },
  methods: {
    activeFilterItemLabel (filter) {
      switch (filter) {
        case 'default':
          return 'You haven`t made any orders yet'
        case 'new':
          return ' No items to pay yet'
        case 'processing':
          return ' No items to ship yet'
        case 'in-transit':
          return ' No items to receive yet'
        case 'delivered':
          return 'No items completed'
        case 'declined':
          return 'No items cancelled'

        default:
          break
      }
    },
    viewOrder (order) {
      const modalParams = {
        content: AppOrderDetails,
        bind: {
          order: order,
          filter: this.activeFilter
        }
      }

      this.$store.dispatch('modal/open', modalParams)
    },
    filterOrders (filterBy) {
      this.activeFilter = filterBy
      if (filterBy === 'default') {
        this.getOrders()
      } else {
        this.filteredOrders = []
        let forder = this.orders.filter(function (order) {
          for (let index = 0; index < order.orderItems.length; index++) {
            const item = order.orderItems[index]
            switch (item.status) {
              case 'cancelled':
                if (item.status === 'cancelled' && filterBy === 'declined') {
                  return order
                }
                break
              default:
                if (item.status === filterBy) {
                  return order
                }
                break
            }
          }
        })
        forder.forEach((element) => {
          this.filteredOrders.push(element)
        })
      }
    },
    getOrders () {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        return this.$http
        .get(
          `${this.$config.API_URL}/customers/${this.$store.state.auth.user.uid}/orders`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
          }
        )
        .then((res) => {
          this.orders = res.data
          this.filteredOrders = res.data
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page-order-history.vue